import { render, staticRenderFns } from "./BranchUser.vue?vue&type=template&id=cc7a0bf0&scoped=true&lang=pug&"
import script from "./BranchUser.vue?vue&type=script&lang=ts&"
export * from "./BranchUser.vue?vue&type=script&lang=ts&"
import style0 from "./BranchUser.vue?vue&type=style&index=0&id=cc7a0bf0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7a0bf0",
  null
  
)

export default component.exports